<p-table
  #dt
  [value]="reports"
  [(selection)]="selectedReports"
  dataKey="analysisNo"
  [rowHover]="true"
  [loading]="false"
  [paginator]="false"
  [scrollable]="true"
  scrollHeight="70vh"
  (onRowSelect)="this.selectedReportsEvent.emit(selectedReports)"
  (onRowUnselect)="this.selectedReportsEvent.emit(selectedReports)"
  (onHeaderCheckboxToggle)="this.selectedReportsEvent.emit(selectedReports)"
  groupRowsBy="specNumber"
  rowGroupMode="subheader"
  >
  <ng-template pTemplate="header">
    <tr>
      <th style="min-width: 4%" class="justify-center">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <th style="min-width: 22%" [pSortableColumn]="'analysisNo'">
        {{ "reportPartList.reportNo" | translate }}
        <p-sortIcon [field]="'analysisNo'"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="analysisNo"
          display="menu"
          [showOperator]="false"
          [showAddButton]="false"
          showMatchModes="true"
          matchMode="contains"
          showClearButton="true"
          showApplyButton="true"
          showMenu="true"
          >
        </p-columnFilter>
      </th>
      <th style="min-width: 22%" pSortableColumn="dateOfAnalysis">
        {{ "reportPartList.date" | translate }}
        <p-sortIcon [field]="'dateOfAnalysis'"></p-sortIcon>
        <p-columnFilter
          type="date"
          field="dateOfAnalysis"
          display="menu"
          [showOperator]="false"
          [showAddButton]="false"
          locale="de-DE"
          showClearButton="true"
          showApplyButton="true"
          showMenu="true"
          >
        </p-columnFilter>
      </th>
      <th style="min-width: 20%">
        {{ "reportPartList.extractionDetails" | translate }}
        <p-columnFilter
          type="text"
          field="extractionDetails"
          display="menu"
          [showOperator]="false"
          [showAddButton]="false"
          showMatchModes="true"
          matchMode="contains"
          showClearButton="true"
          showApplyButton="true"
          showMenu="true"
          >
        </p-columnFilter>
      </th>
      <th style="min-width: 12%" [pSortableColumn]="'ioResult'">
        {{ "dashboard.result" | translate }}
        <p-sortIcon [field]="'ioResult'"></p-sortIcon>
        <p-columnFilter
          type="numeric"
          field="ioResult"
          display="menu"
          [showOperator]="false"
          [showAddButton]="false"
          showMatchModes="true"
          showClearButton="true"
          showApplyButton="true"
          showMenu="true"
          >
        </p-columnFilter>
      </th>
      <th style="min-width: 18%">
        <div class="flex justify-between w-full">
          <div>{{ "reportPartList.yourComment" | translate }}</div>
        </div>
        <p-columnFilter
          type="text"
          field="comment"
          display="menu"
          [showOperator]="false"
          [showAddButton]="false"
          showMatchModes="true"
          showClearButton="true"
          showApplyButton="true"
          showMenu="true"
          >
        </p-columnFilter>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="groupheader" let-row>
    <tr pRowGroupHeader>
      <td colspan="2">
        <span class="font-bold ml-2"
          >{{ "partlist.spec" | translate }}: {{ row.specNumber }}</span
          >
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="groupfooter" let-row>
      <tr class="p-rowgroup-footer"></tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-index="rowIndex">
      <tr>
        <td style="min-width: 4%" class="flex justify-center">
          <p-tableCheckbox [value]="rowData" [index]="index"></p-tableCheckbox>
        </td>
        <td style="min-width: 22%">
          {{ rowData.analysisNo || "-" }}
        </td>
        <td style="min-width: 22%">
          {{ rowData.dateOfAnalysis | date: "dd.MM.yyyy"}}
        </td>
        <td style="min-width: 20%">
          {{ rowData.extractionDetails || "-" }}
        </td>
        <td style="min-width: 12%">
          @if (rowData.ioResult === true) {
            <strong>{{
              "dashboard.iO" | translate
            }}</strong>
          }
          @if (rowData.ioResult === false) {
            <strong>{{
              "dashboard.niO" | translate
            }}</strong>
          }
          @if (rowData.ioResult === null) {
            <strong>{{
              "dashboard.ka" | translate
            }}</strong>
          }
        </td>
        <td style="min-width: 18%">
          {{ rowData.comment }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" style="text-align: left">
          {{ "limitfinder.noReports" | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
